<div trans>Are you sure you want to delete this comment?</div>
<div class="actions">
    <button type="button" mat-button (click)="close(false)" trans>Cancel</button>
    <button type="button" mat-raised-button color="accent" (click)="close(true)" trans>Delete</button>
</div>
